import React from 'react';
import { Navigate } from 'react-router-dom';
import { IsValidLoginAuth, IsValidSemiAuth } from 'common/storage';

const RootRedirect = () => {
  try {
    const isValidLogin = IsValidLoginAuth();
    const isValidSemi = IsValidSemiAuth();
    const target = (isValidLogin || isValidSemi) ? '/home' : '/login?mode=0';
    return <Navigate to={target} replace />;
  } catch (err) {
    return <Navigate to={'/login?mode=0'} replace />;
  }
};

export default RootRedirect;
